module.exports = __webpack_public_path__ + "img/proIcon.087eb4df.svg";